import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import DataTable from '../../../../../../components/DataTable/DataTable.js';
import { set } from 'lodash';

const useStyles = makeStyles((theme) => ({
    root: {},
    content: {
        padding: 0,
    },
    inner: {
        minWidth: 700,
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end',
    },
    primaryButton: {
        color: theme.palette.primary.main
    },
    errorButton: {
        color: theme.palette.error.main
    },
    infoButton: {
        color: theme.palette.info.main
    },
    titles: {
        marginTop: '20px',
        marginBottom: '10px',
        fontFamily: 'Roboto',
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: 1.6,
        letterSpacing: '0.0075em',
    },
    customTable: {
        '& .MuiTable-root': {
            borderCollapse: 'unset',
        },
        '& .MuiTableCell-root': {
            border: 'unset',
            paddingTop: 0,
            paddingBottom: 0,
        },
    },
}));

const BridgeSiteTable = (props) => {
    const { data, id, title } = props;
    const dispatch = useDispatch();
    const classes = useStyles();
    const userId = useSelector(state => state.session.user.id);
    const [columns, setColumns] = useState([]);
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (data && data.length > 0) {
            setColumns(Object.keys(data[0]));
            setItems(data);
        }
    }, [data]);
    

    const camelToTitle = (str) => {
        if (!str) return "";
        return str
            // Insert space before capital letters that are followed by lowercase (handles acronyms properly)
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            // Insert space between two capitals when the second is followed by lowercase (e.g., "IDNumber" -> "ID Number")
            .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
            // Capitalize the first character
            .replace(/^./, (char) => char.toUpperCase())
            .trim();
    }

    return (
        <div className={classes.customTable}>
            <DataTable
                title={title}
                id={id}
                key={id}
                data={items}
                columns={columns.map((col) => ({ name: col, label: camelToTitle(col) }))}   
                ></DataTable>
        </div>
        
    );

};

BridgeSiteTable.propTypes = {
    data: PropTypes.array,
    id: PropTypes.string,
    title: PropTypes.string
};

export default BridgeSiteTable;
